//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

export const Permissions = {
  FanreelModerate: 'fanreel:moderate',
} as const;
